import { useState } from "react";

export const useCopyToClipboard = () => {
  const [copySuccess, setCopySuccess] = useState(false);

  const copyToClipBoard = async (copyMe: string) => {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = copyMe;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      textArea.style.opacity = "0";
      textArea.style.pointerEvents = "none";
      textArea.setAttribute("readonly", "");

      document.body.appendChild(textArea);

      if (navigator.userAgent.match(/ipad|iphone/i)) {
        const range = document.createRange();
        range.selectNodeContents(textArea);
        const selection = window.getSelection();
        if (selection) {
          selection.removeAllRanges();
          selection.addRange(range);
        }
        textArea.setSelectionRange(0, 999999);
      } else {
        textArea.select();
      }

      const successful = document.execCommand("copy");
      try {
        document.body.removeChild(textArea);
      } catch (err) {
        console.info("CTC");
      }

      if (successful) {
        setCopySuccess(true);
        setTimeout(() => {
          setCopySuccess(false);
        }, 1500);
      } else {
        setCopySuccess(false);
        const urlElement = document.querySelector(
          `[data-url="${copyMe}"]`
        ) as HTMLElement;
        if (urlElement) {
          urlElement.style.userSelect = "text";
          (urlElement.style as any).webkitUserSelect = "text";
          (urlElement.style as any).mozUserSelect = "text";
          (urlElement.style as any).msUserSelect = "text";
        }
      }
    } catch (err) {
      setCopySuccess(false);
    }
  };

  return { copySuccess, copyToClipBoard };
};
